import { FC } from 'react';
import { faCircleUser, faSearch } from '~/assets';
import {
  Card,
  Description,
  IconCard,
  IconSearch,
  Name,
  Row,
  RowButtonSearch,
  SearchIconBox,
} from './styles';

type Props = {
  name?: string;
  refDocument?: string;
  type?: string;
  onPress?(): void;
};

const CustomersRow: FC<Props> = ({
  name = '',
  refDocument = '',
  type = '',
  onPress = () => {},
}) => (
  <Card>
    <Row>
      <IconCard icon={faCircleUser} />
      <Name>{name}</Name>
    </Row>
    <Row>
      <Description>{refDocument}</Description>
    </Row>
    <Row>
      <Description>{type}</Description>
    </Row>
    <RowButtonSearch>
      <SearchIconBox id="onPress_customer" onPress={onPress}>
        <IconSearch icon={faSearch} />
      </SearchIconBox>
    </RowButtonSearch>
  </Card>
);

export default CustomersRow;
